export enum SCOPE_OPTIONS {
  SKUS = 'skus',
  PRODUCTS = 'products',
  COLLECTIONS = 'collections',
  CATEGORIES = 'categories',
  BRANDS = 'brands',
}
